import { PciChartProps } from "reports/types";
import { black, producing } from "../../../../../constants/colors";
import PciCustomLegend from "reports/pages/customers/pci/Utils/PciCustomLegend";
import PciBiAxialBarChart from "./PciBiAxialBarChart";

const bars = [
  {
    key: "netOutput",
    name: "Production Count",
    fill: black,
    label: true,
    yAxisId: "left",
  },
  {
    key: "oeePercent",
    name: "OEE Percent",
    fill: producing,
    label: true,
    yAxisId: "right",
  },
];

/**
 * generate and create bar chart based on given data
 */
export default function WeeklyProduction({
  data,
  width,
  height,
}: PciChartProps) {
  const title = "Weekly Production";
  return (
    <PciBiAxialBarChart
      data={data ? data : []}
      bars={bars}
      xLabel={""}
      yLabel={"Units Processed (1000s)"}
      y2Label={"OEE Percentage %"}
      title={title}
      width={width}
      height={height}
      legend={PciCustomLegend(width, title)}
    />
  );
}
